module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_3.dbdc9aa0.png";